import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  writeBatch,
  collectionGroup,
  orderBy,
} from 'firebase/firestore/lite';
import Skeleton from '@material-ui/lab/Skeleton';
import { Table } from 'antd';
import CouponManageDialog from './CouponDialog';
import moment from 'moment';
import { Popconfirm } from 'antd';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { useSelector } from 'react-redux';
import Switch from '@material-ui/core/Switch';
import { Tooltip } from 'antd';
import { makeStyles } from '@material-ui/core/styles';

let couponsBackupArrMix = [];
let couponsBackupArrChild = [];

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function PromoCodesContainer(props) {
  const [couponDialogState, setcouponDialogState] = useState(false);
  const [loadingCodes, setloadingCodes] = useState(false);
  const [codesList, setcodesList] = useState([]);
  const classes = useStyles();
  const columns = [
    {
      title: 'NFT Title',
      dataIndex: 'title',
      width: '20%',
      render: (text, obj) => (
        <Tooltip title={text} classes={classes}>
          <span>
            {text
              ? text.length > 24
                ? text.substring(0, 24) + '...'
                : text
              : '-'}{' '}
            {obj.index ? '(#' + obj.index + ')' : ''}
          </span>
        </Tooltip>
      ),
      sorter: (a, b) => {
        if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
        if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
        else return 0;
      },
    },
    {
      title: 'Coupon',
      dataIndex: 'promoCode',
      sorter: (a, b) => {
        if (a.promoCode < b.promoCode) return -1;
        if (a.promoCode > b.promoCode) return 1;
        else return 0;
      },
    },
    {
      title: 'Type',
      dataIndex: 'type',
    },

    {
      title: 'Discount',
      dataIndex: 'value',
      render: (text, obj) => (
        <span>
          {text}
          {obj.type === 'PRICE' ? ' BSV' : obj.type === 'PERCENTAGE' ? '%' : ''}
        </span>
      ),
    },
    {
      title: 'Status',

      dataIndex: 'endTimestamp',
      render: (text, obj) => {
        let cTime = Number(moment().format('x'));
        if (
          obj.usageLimit &&
          obj.usageLimit !== -1 &&
          obj.usage >= obj.usageLimit
        ) {
          return <span style={{ color: 'red' }}>Expired</span>;
        } else if (cTime > Number(obj.endTimestamp)) {
          return <span style={{ color: 'red' }}>Expired</span>;
        } else if (cTime < Number(obj.startTimestamp)) {
          return <span>In-Active</span>;
        } else if (obj.startTimestamp) {
          return <span style={{ color: 'green' }}>Active</span>;
        }
      },
      sorter: (a, b) => a.startTimestamp - b.startTimestamp,
    },
    {
      title: 'Start Date',

      dataIndex: 'startTimestamp',
      width: '12rem',
      render: (text) => (
        <span>
          {text ? moment(Number(text)).format('LT - D MMM, YYYY') : ''}
        </span>
      ),
      sorter: (a, b) => a.startTimestamp - b.startTimestamp,
    },
    {
      title: 'End Date',
      dataIndex: 'endTimestamp',
      width: '12rem',
      render: (text) => (
        <span>
          {text ? moment(Number(text)).format('LT - D MMM, YYYY') : ''}
        </span>
      ),
      sorter: (a, b) => a.endTimestamp - b.endTimestamp,
    },
    {
      title: 'Usage',
      dataIndex: 'usageLimit',
      width: '12rem',
      render: (text, obj) => {
        if (obj.couponType === 'WITH_USAGE_LIMIT' && !obj.hideUsage) {
          return (
            <span>
              Usage: {obj && obj.usage ? obj.usage : '0'}
              <br />
              {text && text !== -1 ? `Limit: ${text}` : ''}
            </span>
          );
        }
      },
      sorter: (a, b) => a.endTimestamp - b.endTimestamp,
    },
  ];
  const [selectedRowKeys, setselectedRowKeys] = useState([]);
  const [deletePopupVisible, setdeletePopupVisible] = useState(false);
  const [deletePopupLoading, setdeletePopupLoading] = useState(false);

  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const userWalletRedux = useSelector((state) => state.walletReducer);
  const [switchVal, setswitchVal] = useState(true);
  const [nftData, setnftData] = useState([]);

  useEffect(() => {
    if (userDataRedux?.uid) {
      setloadingCodes(true);
      getNfts();
    }
  }, [userDataRedux]);

  useEffect(() => {
    return () => {
      couponsBackupArrMix = [];
      couponsBackupArrChild = [];
    };
  }, []);

  const getNfts = async () => {
    let queryArr = [];
    queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
    queryArr.push(where('adminState', '==', 'ACCEPT'));
    queryArr.push(where('activeInMarketPlace', '==', true));
    queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
    queryArr.push(orderBy('creationDate', 'desc'));
    let dataObj = await getDocs(query(...queryArr));

    let nftArr = [];
    dataObj.docs.map(async (ele, index) => {
      nftArr.push({ ...ele.data(), id: ele.id });
    });

    setnftData([...nftArr]);
    getNftsCouponsList([...nftArr]);
  };

  const getNftsCouponsList = async (nftList) => {
    let lCouponsArrChildern = [];
    let lCouponsArrMix = [];
    setloadingCodes(true);

    let walletOwnedNfts;
    if (nftList) {
      walletOwnedNfts = nftList;
    } else {
      walletOwnedNfts = nftData;
    }

    try {
      let snapshot = await getDocs(
        query(
          collectionGroup(firebaseFireStore, 'coupons'),
          where('couponType', '==', 'WITH_USAGE_LIMIT'),
          where('creatorId', '==', userDataRedux.uid),
        ),
      );

      snapshot.forEach((doc, index) => {
        let cObj = doc.data();
        if (cObj.isMultiple && cObj.subNfts) {
          let subCoupons = [];

          Object.values(cObj.subNfts).map((ele, indx) => {
            subCoupons.push({
              ...doc.data(),
              key:
                doc.data().couponId +
                '_tokenid_' +
                cObj.tokenId +
                '_nftid_' +
                ele.nftId,
              isMultiple: true,
              index: ele.index,
              hideUsage: true,
            });
            lCouponsArrMix.push({
              ...doc.data(),
              key:
                doc.data().couponId +
                '_tokenid_' +
                cObj.tokenId +
                '_nftid_' +
                ele.nftId,
              index: ele.index,
              count: Object.keys(cObj.subNfts).length,
            });
          });

          if (subCoupons.length > 0) {
            lCouponsArrChildern.push({
              key:
                'parent_NFT_Usage_Limit' +
                doc.data().couponId +
                '_tokenid_' +
                cObj.tokenId,
              title: subCoupons[0].title,
              children: subCoupons.sort((x, y) => (x.index > y.index ? 1 : -1)),
              couponType: 'WITH_USAGE_LIMIT',
              usage: subCoupons[0].usage,
              usageLimit: subCoupons[0].usageLimit,
            });
          }
        } else {
          lCouponsArrChildern.push({
            ...doc.data(),
            key: doc.data().couponId,
          });
          lCouponsArrMix.push({
            ...doc.data(),
            key: doc.data().couponId,
          });
        }
      });

      //coupons without usage limit
      await Promise.all(
        walletOwnedNfts.map(async (ele, index) => {
          //get coupons
          let snap = await getDocs(
            query(
              collection(
                firebaseFireStore,
                'musicartNfts',
                ele.tokenId,
                'coupons',
              ),
            ),
          );

          if (!snap || snap.empty) {
            return null;
          }

          if (ele.isMultiple) {
            let eleNftIds = [];
            Object.values(ele.multipleNftDetails).map((multiEle) => {
              if (
                (multiEle.userId === userDataRedux.uid ||
                  multiEle.userAddress === userWalletRedux.addressPath0) &&
                multiEle.nftId
              ) {
                eleNftIds.push(multiEle.nftId);
              }
            });

            let subCoupons = [];
            snap.forEach((doc, index) => {
              if (
                (!doc.data().couponType ||
                  doc.data().couponType !== 'WITH_USAGE_LIMIT') &&
                doc.data().nftId &&
                eleNftIds.includes(doc.data().nftId)
              ) {
                subCoupons.push({
                  ...doc.data(),
                  title: ele.tokenName,
                  key: doc.data().couponId,
                  isMultiple: true,
                });
                lCouponsArrMix.push({
                  ...doc.data(),
                  title: ele.tokenName,
                  key: doc.data().couponId,
                });
              }
            });

            if (subCoupons.length > 0) {
              lCouponsArrChildern.push({
                key: 'parent_NFT_' + ele.tokenId,
                title: subCoupons[0].title,
                children: subCoupons.sort((x, y) =>
                  x.index > y.index ? 1 : -1,
                ),
              });
            }
          } else if (ele.tokenId) {
            snap.forEach((doc) => {
              if (
                !doc.data().couponType ||
                doc.data().couponType !== 'WITH_USAGE_LIMIT'
              ) {
                lCouponsArrChildern.push({
                  ...doc.data(),
                  title: ele.tokenName,
                  key: doc.data().couponId,
                });
                lCouponsArrMix.push({
                  ...doc.data(),
                  title: ele.tokenName,
                  key: doc.data().couponId,
                });
              }
            });
          }
        }),
      );

      couponsBackupArrChild = lCouponsArrChildern;
      couponsBackupArrMix = lCouponsArrMix;

      setcodesList(lCouponsArrChildern);
      setloadingCodes(false);
    } catch (err) {
      console.log('err', err, err.response, err.data, err.message);
      setloadingCodes(false);
    }
  };

  const deleteCoupons = async () => {
    setdeletePopupLoading(true);
    let batch = writeBatch(firebaseFireStore);
    let modifiedObj = [...couponsBackupArrMix];

    let lselectedRowKeys = [...selectedRowKeys];
    let rmTokenIds = {};

    selectedRowKeys.map((sKey, sindx) => {
      if (sKey.includes('_tokenid_') && sKey.includes('_nftid_')) {
        let rmKey = sKey.slice(0, sKey.indexOf('_nftid_'));

        if (rmTokenIds[rmKey] && rmTokenIds[rmKey].count) {
          rmTokenIds[rmKey].count = rmTokenIds[rmKey].count + 1;
          rmTokenIds[rmKey].ids.push(sKey);
        } else {
          let IdIndex = modifiedObj.findIndex((x) => x.key === sKey);
          if (IdIndex !== -1) {
            rmTokenIds[rmKey] = {
              count: 1,
              totalCount: modifiedObj[IdIndex].count,
              ids: [sKey],
            };
          }
        }
      }
    });

    Object.keys(rmTokenIds).map((rKey, rIndx) => {
      let rEle = rmTokenIds[rKey];
      if (rEle && rEle.totalCount === rEle.count) {
        //delete parent
        let cId = rKey.slice(0, rKey.indexOf('_tokenid_'));
        let tId = rKey.slice(rKey.indexOf('_tokenid_') + 9, rKey.length);

        let couponRef = doc(
          firebaseFireStore,
          'musicartNfts',
          tId,
          'coupons',
          cId,
        );
        batch.delete(couponRef);
      } else {
        let cId = rKey.slice(0, rKey.indexOf('_tokenid_'));
        let tId = rKey.slice(rKey.indexOf('_tokenid_') + 9, rKey.length);

        let IdIndex = modifiedObj.findIndex((x) => x.key === rEle.ids[0]);
        if (IdIndex !== -1) {
          let couponObj = { ...modifiedObj[IdIndex] };

          let nObj = { ...couponObj.subNfts };
          rEle.ids.map((ele3) => {
            let nNftId = ele3.slice(ele3.indexOf('_nftid_') + 7, ele3.length);
            delete nObj[nNftId];
          });

          let couponRef = doc(
            firebaseFireStore,
            'musicartNfts',
            tId,
            'coupons',
            cId,
          );
          batch.update(couponRef, { subNfts: nObj });
        }
      }

      lselectedRowKeys = [...lselectedRowKeys].filter((x) => !x.includes(rKey));
    });

    lselectedRowKeys = [...lselectedRowKeys].filter(
      (x) => !x.includes('parent_NFT_'),
    );

    lselectedRowKeys.map((ele) => {
      let IdIndex = modifiedObj.findIndex((x) => x.key === ele);
      if (IdIndex !== -1) {
        let couponObj = { ...modifiedObj[IdIndex] };

        if (couponObj.isMultiple && couponObj.multiData) {
          couponObj.multiData.map((eledd) => {
            batch.delete(
              doc(
                firebaseFireStore,
                'musicartNfts',
                eledd.tokenId,
                'coupons',
                eledd.couponId,
              ),
            );
          });
          return;
        } else {
          let couponRef = doc(
            firebaseFireStore,
            'musicartNfts',
            couponObj.tokenId,
            'coupons',
            couponObj.couponId,
          );
          batch.delete(couponRef);
        }
      }
    });
    await batch.commit();
    await getNftsCouponsList();
    setdeletePopupLoading(false);
    setdeletePopupVisible(false);
    setselectedRowKeys([]);
    toast.success('Coupon deleted successfully', {
      position: 'bottom-left',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      zIndex: 2147483641,
    });
  };

  const onSelectChange = (selectedRowKeys, obj) => {
    setselectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;
  return (
    <div>
      <div className="mb-4" style={{ display: 'flex', alignItems: 'center' }}>
        <Popconfirm
          title="Are you sure you want to delete these Coupons?"
          onConfirm={deleteCoupons}
          okText="Yes"
          cancelText="No"
          okButtonProps={{ loading: deletePopupLoading }}
          visible={deletePopupVisible}
          onCancel={() => setdeletePopupVisible(false)}
        >
          <button
            className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
            onClick={() => setdeletePopupVisible(true)}
            disabled={!hasSelected}
            style={{
              opacity: hasSelected ? 1 : 0.7,

              textTransform: 'uppercase',
            }}
          >
            Delete
          </button>
        </Popconfirm>
        <div style={{ marginLeft: '10px' }} className="create__coupon">
          <button
            className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
            onClick={() => {
              setcouponDialogState(true);
            }}
          >
            Create Coupon
          </button>
        </div>

        <div style={{ marginLeft: 'auto' }}>
          <Tooltip title="Merge Sub NFTs">
            <Switch
              checked={switchVal}
              onChange={(e) => {
                setswitchVal(e.target.checked);

                if (e.target.checked) {
                  setcodesList([...couponsBackupArrChild]);
                } else {
                  setcodesList(
                    [...couponsBackupArrMix].sort((x, y) =>
                      x.index > y.index ? 1 : -1,
                    ),
                  );
                }
              }}
              name="Merge View"
              color="primary"
            />
          </Tooltip>
        </div>
      </div>
      <div className="nft-card-con">
        {loadingCodes && (
          <div
            className="flex 	w-full my-6 mx-6"
            style={{ flexDirection: 'column' }}
          >
            {/* <Skeleton animation="wave" height={20} width="60%" /> */}
            <Table
              rowKey="key"
              pagination={false}
              dataSource={[...Array(10)].map((_, index) => ({
                key: `key${index}`,
              }))}
              columns={columns.map((column) => {
                return {
                  ...column,
                  render: function renderPlaceholder() {
                    return (
                      <Skeleton
                        key={column.dataIndex}
                        title={true}
                        paragraph={false}
                      />
                    );
                  },
                };
              })}
            />
          </div>
        )}

        {!loadingCodes && codesList.length === 0 && (
          <div className="text-center w-full text-blueGray-500">
            <p className="text-center">0 Coupons found</p>
          </div>
        )}

        {!loadingCodes && codesList.length > 0 && (
          <div className="w-full">
            <Table
              pagination={false}
              columns={columns}
              dataSource={codesList}
              rowSelection={{ ...rowSelection, checkStrictly: false }}
            />
          </div>
        )}
        <CouponManageDialog
          dialogState={couponDialogState}
          setdialogState={setcouponDialogState}
          codesList={codesList}
          setcodesList={setcodesList}
          getNftsCouponsList={getNftsCouponsList}
          walletOwnedNfts={nftData}
        />
      </div>
    </div>
  );
}
